import { AfterViewInit, Directive, ElementRef, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[selectOnFocus]',
  standalone: true
})
export class SelectOnFocusDirective implements AfterViewInit {
  #renderer = inject(Renderer2);
  #elementRef = inject(ElementRef);

  #destroyFocusListener: () => void;

  constructor() {}

  ngAfterViewInit(): void {
    this.#destroyFocusListener = this.#renderer.listen(this.#elementRef.nativeElement, 'focus', () => {
      this.#elementRef.nativeElement.select();
    });
  }

  ngOnDestroy(): void {
    this.#destroyFocusListener && this.#destroyFocusListener();
  }
}
